import { storyHighlights } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

function Story() {
  return (
    <section id="story" className="relative border-y border-background-900 bg-background-900/40 py-16 md:py-24">
      <div className="container-x">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="专题精选"
            title="值得花一整晚读的长文"
            desc="深度追踪不是快讯的堆叠，而是把一条线索走到底。挑一篇，坐下来慢慢读。"
          />
          <span className="hidden shrink-0 items-center gap-2 text-sm text-foreground-500 lg:flex">
            <i className="ri-hourglass-line text-accent-400" aria-hidden="true"></i>
            平均阅读 12 分钟以上
          </span>
        </div>

        <div className="mt-10 space-y-8">
          {storyHighlights.map((s, i) => (
            <article
              key={s.id}
              className="grid grid-cols-1 gap-6 overflow-hidden rounded-3xl border border-background-800 bg-background-950/70 p-5 transition-colors hover:border-secondary-500/30 md:grid-cols-2 md:p-7"
            >
              <div className={`relative min-h-[220px] overflow-hidden rounded-2xl md:min-h-[300px] ${i % 2 === 1 ? "md:order-2" : ""}`}>
                <img
                  src={s.image}
                  alt={`深度专题《${s.title}》配图`}
                  className="absolute inset-0 h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent"></div>
                <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-secondary-500 px-3 py-1 text-xs font-medium text-background-950">
                  <i className="ri-fire-line" aria-hidden="true"></i>
                  {s.kicker}
                </span>
              </div>

              <div className={`flex flex-col justify-center ${i % 2 === 1 ? "md:order-1" : ""}`}>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-calendar-line" aria-hidden="true"></i>
                    {s.date}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    约 {s.minutes} 分钟
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-secondary-300">
                    <i className="ri-bookmark-line" aria-hidden="true"></i>
                    {s.reading}
                  </span>
                </div>
                <h3 className="mt-4 font-serif text-2xl font-black leading-snug tracking-tight text-foreground-50 md:text-3xl">
                  <a href="#subscribe" className="transition-colors hover:text-secondary-300">
                    {s.title}
                  </a>
                </h3>
                <p className="mt-4 text-[15px] leading-relaxed text-foreground-400">{s.excerpt}</p>
                <a
                  href="#subscribe"
                  className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-6 py-3 text-sm font-medium text-background-950 transition-colors hover:bg-secondary-400"
                >
                  订阅后阅读全文
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Story;